import Product from "./product";

export const productsList = [
  <Product
    index={0}
    path="/assets/Pepperoni-Pizza.png"
    name="pizza_with_peperoni"
    type="pizza"
    time="14-20"
    cost="12"
  />,
  <Product
    index={1}
    path="/assets/mushroom-pizza.png"
    name="pizza_with_mushroom"
    type="pizza"
    time="11-16"
    cost="9"
  />,
  <Product
    index={2}
    path="/assets/pizzaCheese.png"
    name="pizza_with_cheese"
    type="pizza"
    time="16-25"
    cost="14"
  />,
  <Product
    index={3}
    path="/assets/burger.png"
    name="burger"
    type="burger"
    time="11-17"
    cost="13"
  />,
  <Product
    index={4}
    path="/assets/fries.png"
    name="fries"
    type="fries"
    time="5-8"
    cost="5"
  />,
  <Product
    index={5}
    path="/assets/chickenWings.png"
    name="chicken_wings"
    type="pack"
    time="10-15"
    cost="8"
  />,
];
